import apiClient from '../helpers/ApiClient'
import { handleError, authHeader } from '@/helpers/ApiClient';

export const productOptionService = {
    getOptionLists,
    addOptionList,
    updateOptionList,
    deleteOptionList,
    deleteOptionLists,
    saveOptionItems,
}

function getOptionLists() {
    return apiClient.get(`/product_option/list`, {headers: authHeader()})
        .then((response) => response.data)
        .catch((error) => handleError(error));
}

function addOptionList(optionList) {
    return apiClient.post(`/product_option/list`, optionList, {headers: authHeader()})
        .then((response) => response.data)
        .catch((error) => handleError(error));
}

function updateOptionList(optionListId, optionList) {
    return apiClient.patch(`/product_option/list/${optionListId}`, optionList, {headers: authHeader()})
        .then((response) => response.data)
        .catch((error) => handleError(error));
}

function deleteOptionList(optionListId) {
    return apiClient.delete(`/product_option/list/${optionListId}`, {headers: authHeader()})
        .then((response) => response.data)
        .catch((error) => handleError(error));
}

function deleteOptionLists(optionListIds) {
    return apiClient.delete(`/product_option/list`, {headers: authHeader(), data: optionListIds})
        .then((response) => response.data)
        .catch((error) => handleError(error));
}

function saveOptionItems(optionListId, optionItems) {
    return apiClient.patch(`/product_option/list/${optionListId}/items`, optionItems, {headers: authHeader()})
        .then((response) => response.data)
        .catch((error) => handleError(error));
}
